export default __webpack_public_path__ + "static/polco-logo.4a80d671.svg";